import { useSubmitMessage } from 'src/hooks/api';
import { PopularQuestionsListProps } from './PopularQuestionsList';

import './PopularQuestions.sass';
interface PopularQuestionProps extends PopularQuestionsListProps {
	text: string;
}

const PopularQuestion = ({ text, onChunk, onComplete }: PopularQuestionProps) => {
	const submit = useSubmitMessage({
		userInput: text,
		onChunk,
		onComplete
	});

	const handleMessage = () => {
		if (!text.length) return;
		submit();
	};

	return (
		<article onClick={handleMessage} className="chat-message user-message">
			<div className="message-wrapper">
				<span className="text">{text}</span>
			</div>
		</article>
	);
};

export default PopularQuestion;
